__turbopack_context__.v({
  "container": "VerifiedBySection-module-scss-module__lYuB0a__container",
  "description": "VerifiedBySection-module-scss-module__lYuB0a__description",
  "partners": "VerifiedBySection-module-scss-module__lYuB0a__partners",
});
